// La hoja impresa de los códigos de respaldo (Peaje U-02).
//
// Antes, «Imprimir» llamaba a `window.print()` a secas y salía la pantalla
// entera: menú, tarjeta, fondo. Aquí la hoja vive oculta en pantalla y, al
// imprimir, es lo ÚNICO visible: título, la cuenta, la fecha y los diez
// códigos en dos columnas. Nada más.
//
// El estilo de impresión va por `useEstiloDeImpresion` (una hoja
// construida): un `<style>` inyectado lo tira la CSP en silencio. Va
// `position: fixed` y no en un portal para que se pinte igual en las
// pruebas sin navegador (el renderizador de servidor no admite portales).
// Se oculta con `hidden print:block` y NO con el atributo `hidden`: el
// preflight de Tailwind lo fija con !important en una capa, y en la
// cascada un !important con capa gana a la hoja construida, que no tiene
// capa. Con el atributo, la hoja impresa salía en blanco (medido el
// 6 oct 2026 en Chromium, capturas/despues/2fa-impresa-*).
import { useEstiloDeImpresion } from '../experiencia/estiloDeImpresion';

import { CSS_HOJA, ID_HOJA, fechaDeHoja } from './hojaDeCodigos';

export default function HojaDeCodigos({ codigos = [], cuenta, fecha }) {
  useEstiloDeImpresion(CSS_HOJA);
  const hoja = (
    <section id={ID_HOJA} className="hidden print:block" aria-hidden="true">
      <h1>Códigos de respaldo de TEGO</h1>
      {cuenta ? <p>Cuenta: {cuenta}</p> : null}
      <p>Fecha: {fecha || fechaDeHoja()}</p>
      <ol>
        {codigos.map((c) => <li key={c}>{c}</li>)}
      </ol>
    </section>
  );
  return hoja;
}
